/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import ImageUploader from './common/UploadImage';
import Input from './common/Input';
import { Badge, Form } from 'react-bootstrap';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';

const EnrollToday = () => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [selectedImages, setSelectedImages] = useState([]);
    const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [firstNumber, setFirstNumber] = useState('');
    const [secondNumber, setSecondNumber] = useState('');
    const [thirdNumber, setThirdNumber] = useState('');
    const [firstLabel, setFirstLabel] = useState('');
    const [secondLabel, setSecondLabel] = useState('');
    const [thirdLabel, setThirdLabel] = useState('');
    const [image, setImage] = useState('');

    const navigate = useNavigate();
    const fetchClient = () => {
        coreContext.fetchSelfEnrollToday(authContext.itemId);
    }

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    useEffect(fetchClient, []);

    const populateClient = () => {

        setValue('title', coreContext.client.enroll_today_title);
        setValue('message', coreContext.client.enroll_today_message);
        setValue('firstnumber', coreContext.client.enroll_today_no1);
        setValue('secondnumber', coreContext.client.enroll_today_no2);
        setValue('thirdnumber', coreContext.client.enroll_today_no3);
        setValue('firstlabel', coreContext.client.enroll_today_label1);
        setValue('secondlabel', coreContext.client.enroll_today_label2);
        setValue('thirdlabel', coreContext.client.enroll_today_label3);
        // setValue('image', coreContext.client.enroll_today_image);

        // setTitle(coreContext.client.enroll_today_title);
        // setMessage(coreContext.client.enroll_today_message);
        // setFirstNumber(coreContext.client.enroll_today_no1);
        // setSecondNumber(coreContext.client.enroll_today_no2);
        // setThirdNumber(coreContext.client.enroll_today_no3);
        // setFirstLabel(coreContext.client.enroll_today_label1);
        // setSecondLabel(coreContext.client.enroll_today_label2);
        // setThirdLabel(coreContext.client.enroll_today_label3);
        setImage(coreContext.client.enroll_today_image);
    }

    useEffect(populateClient, [coreContext.client]);

    const renderImages = () => {
        if (image)
            return <div className="col-md-6"><img style={{ padding: 5 }} className="img-fluid" src={`http://${image}`} alt='enroll today image' /></div>
    }

    const onImagesUploadHandler = async () => {
        const count = selectedImages.length;
        if (count > 1) { alert('Only one image should be uploaded for this section !'); return; }
        let counter = 0;

        for await (const image of selectedImages) {
            ++counter;
            const formData = new FormData();
            formData.append('itemId', coreContext.client.id);
            formData.append('image', image, image.name);
            formData.append('userId', authContext.userId);
            coreContext.uploadEnrollTodayImage(formData, coreContext.client.id);

            if (counter === count) {
                setTimeout(() => {
                    setSelectedImages([]);
                    fetchClient();
                }, 2000);
                setTimeout(() => {
                    //  navigate('/');
                }, 5000);
            };
        }
    }



    const onEnrollTodaySectionHandler = (data) => {
        coreContext.updateEnrollTodaySection(data.title, data.message, data.firstnumber, data.secondnumber, data.thirdnumber, data.firstlabel, data.secondlabel, data.thirdlabel, authContext.itemId);

    }

    const onImagesSelected = (pictures) => {
        setSelectedImages(pictures);
        //  console.log(pictures);
        if (pictures.length > 0) setUploadButtonDisabled(false); else setUploadButtonDisabled(true);
    }

    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Enroll Today Section</Badge></h3></div>
            <div className="card-body">
                <Form autoComplete='off' onSubmit={handleSubmit(onEnrollTodaySectionHandler)} noValidate>
                    <Input label='Title' value={title} name='title' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Title' />

                    <Input label='Message' value={message} name='message' minLength={2} maxLength={2000} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Message' />

                    <div className="row">
                        <div className="col-md-6">
                            <Input label='First Label' value={firstLabel} name='firstlabel' minLength={1} maxLength={55} required={false} register={register} errors={errors} elementType='text' placeholder='Enter First Label' />
                        </div>
                        <div className="col-md-6">
                            <Input label='First Number' value={firstNumber} name='firstnumber' minLength={1} maxLength={55} required={false} register={register} errors={errors} elementType='text' placeholder='Enter First Number' />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Input label='Second Label' value={secondLabel} name='secondlabel' minLength={1} maxLength={55} required={false} register={register} errors={errors} elementType='text' placeholder='Enter Second Label' />
                        </div>
                        <div className="col-md-6">
                            <Input label='Second Number' value={secondNumber} name='secondnumber' minLength={1} maxLength={55} required={false} register={register} errors={errors} elementType='text' placeholder='Enter Second Number' />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Input label='Third Label' value={thirdLabel} name='thirdlabel' minLength={1} maxLength={55} required={false} register={register} errors={errors} elementType='text' placeholder='Enter Third Label' />
                        </div>
                        <div className="col-md-6">
                            <Input label='Third Number' value={thirdNumber} name='thirdnumber' minLength={1} maxLength={55} required={false} register={register} errors={errors} elementType='text' placeholder='Enter Third Number' />
                        </div>
                    </div>

                    <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()}
                    <Input variant='danger' label={coreContext.message} elementType='label' />
                </Form>
            </div>
        </div>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Upload Enroll Today Image</Badge></h3></div>
            <div className="card-title mx-auto">Best Image Size 1920*820</div>
            <div className="card-body">
                <ImageUploader onImagesSelected={onImagesSelected} maxWidthOrHeight='1920' pictures={selectedImages} />
                <Input value='Upload Images' onClick={onImagesUploadHandler} disabled={uploadButtonDisabled} elementType='button' variant='primary' />&nbsp;&nbsp; {coreContext.renderLoader()}
                <Input variant='danger' label={coreContext.message} elementType='label' />
            </div>
            <div className="card-body">
                <div className="card-title mx-auto"><h3><Badge variant="success">Enroll Today Image</Badge></h3></div>
                <div className="row">
                    {renderImages()}
                </div>
            </div>
        </div>
    </div>
    )
}

export { EnrollToday }